window.ResizeObserver ??= require('@juggle/resize-observer').ResizeObserver;

const $                 = require('jquery');
const _                 = require('underscore');
const { icon }          = require('@fortawesome/fontawesome-svg-core');
const tippy             = require('tippy.js/dist/tippy-bundle.umd.js');
const metrics           = require('../util/metrics');
const tpl               = require('../util/template');
const eventer           = require('../util/eventer');
const menu              = require('../comp/sidenav');
const theme             = require('../theme');
const evtbus            = require('../evtbus');
const evtout            = require('../evtout');
const platform          = require('../platform');
const ManageItem        = require('./manage_item');

tippy.setDefaultProps({
  delay: 100,
  duration: 100,
  offset: [0, 5],
  arrow: false,
  animation: 'scale'
});

let collapseText = false;

const MIN_BREAKS      = [];
const MAX_BREAKS      = [540];
const COLLAPSE_POINT  = 540;

const faIconOpts = { classes: ['fa-icon icon-h-14'] };
const fa = {
  check: require('@fortawesome/pro-light-svg-icons/faCheck').definition,
  adjust: require('@fortawesome/pro-regular-svg-icons/faCircleHalfStroke').definition,
  lightbulb: require('@fortawesome/pro-regular-svg-icons/faLightbulb').definition,
  lightbulbSolid: require('@fortawesome/pro-solid-svg-icons/faLightbulb').definition,
  lightbulbOn: require('@fortawesome/pro-regular-svg-icons/faLightbulbOn').definition,
  bars: require('@fortawesome/pro-light-svg-icons/faBars').definition,
  times: require('@fortawesome/pro-light-svg-icons/faTimes').definition,
  spinnerThird: require('@fortawesome/pro-solid-svg-icons/faSpinnerThird').definition,
  playlistAdd: require('../icons/playlistAdd').definition,
  playlistAddCheck: require('../icons/playlistAddCheck').definition
};

const tooltips = eventer({});
const actions = {
  menu: {
    index: 0,
    icon: fa.bars,
    title: 'Open Menu',
    tip: () => true,
    handler: () => menu.toggle()
  },
  theme: {
    index: 1,
    title: 'Light/Dark Mode',
    tip: () => true,
    handler: () => {
      theme.val = (theme.val !== 'light') ? 'light' : 'dark';
    }
  },
  supplements: {
    index: 4,
    text: 'Supplements',
    handler: () => menu.open('supplements')
  },
  figures: {
    index: 6,
    text: 'Figures',
    handler: () => menu.open('figures')
  },
  metrics: {
    index: 9,
    text: 'Metrics',
    handler: () => menu.open('metrics')
  },
  related: {
    index: 10,
    text: 'Related',
    badge: 10,
    handler: () => menu.open('related')
  },
  references: {
    index: 11,
    text: 'References',
    handler: () => menu.open('references')
  },
  library: {
    index: 102
  }
}

class MenuBar {
  constructor({ container, item, metadata, syncApi }) {
    this._item = item;
    this._data = metadata;
    this._doi = metadata.doi;
    this._syncApi = syncApi;
    this._container = $(container);

    this._render();
    this._bindEvents();
  }

  _render() {
    this._elem = $(`
      <div class="menu-bar wrfont">
        <div class="left">
          ${_.range(20).map(idx => `<span idx=${idx}></span>`).join('')}
        </div>
        <div class="center"></div>
        <div class="right">
          ${_.range(100, 120).map(idx => `<span idx=${idx}></span>`).join('')}
        </div>
      </div>
    `).appendTo(this._container);

    this._renderButtons();
    this.setItem(this._item);
  }

  _bindEvents() {
    menu.on('opened closed', () => {
      const button = this._elem.find('.menu');
      if (menu.isOpen) {
        button.find('svg').replaceWith(icon(fa.times, faIconOpts).html);
        button[0]._tippy.setContent('Close Menu');
      } else {
        button.find('svg').replaceWith(icon(fa.bars, faIconOpts).html);
        button[0]._tippy.setContent('Open Menu');
      }
    });

    const resize = () => {
      const width = this._elem[0].clientWidth;
      this._elem.attr('client-width', width);
      this._elem.attr('min-width', MIN_BREAKS.filter(b => b < width).join(' '));
      this._elem.attr('max-width', MAX_BREAKS.filter(b => b > width).join(' '));

      if (collapseText != (width < COLLAPSE_POINT)) {
        collapseText = !collapseText;
        tooltips.trigger('update');
      }
    };

    const ro = new ResizeObserver(resize);
    ro.observe(this._elem[0]);

    resize();
  }

  _renderButtons() {
    this._addButton('menu');
    this._addThemeButton();
    this._addMetaButtons();
    this._addLibraryButton();
  }

  _addThemeButton() {
    const button = this._createThemeButton();
    button.find('li.system').click(() => theme.val = 'system');
    button.find('li.light').click(() => theme.val = 'light');
    button.find('li.dark').click(() => theme.val = 'dark');
    button.find('li.dark-inverted').click(() => theme.val = 'dark.inverted');
    button.appendTo(this._elem.find(`[idx="${actions['theme'].index}"]`).empty());
  }

  _addMetaButtons() {
    let buttonCount = 0;
    const maxBtnCnt = 3;

    if (this._data.supplements?.length || this._data.videos?.length) {
      this._addButton('supplements', {
        badge: (this._data.supplements?.length || 0) + (this._data.videos?.length || 0)
      });
      buttonCount++;
    }
    if (this._data.figures?.length) {
      this._addButton('figures', { badge: this._data.figures.length });
      buttonCount++;
    }
    metrics({ doi: this._doi, syncApi: this._syncApi }).then(result => {
      if (result.count) {
        this._addButton('metrics', { badge: result.count });
        buttonCount++;
      }
      if (buttonCount < maxBtnCnt && this._data.meta?.abstract) {
        this._addButton('related');
        buttonCount++;
      }
      if (buttonCount < maxBtnCnt && this._data.references?.length) {
        this._addButton('references', { badge: this._data.references.length });
        buttonCount++;
      }
    });
  }

  _addButton(id, opts) {
    opts = Object.assign({}, actions[id], opts);
    return this._createButton(id, opts)
      .appendTo(this._elem.find(`[idx="${opts.index}"]`).empty());
  }

  _createButton(id, opts) {
    const button = $(`
      <menu-button class="${id}" data-tippy-content="${opts.title || ''}" tabindex="0">
        ${tpl.if(opts.spinner, () => icon(fa.spinnerThird, faIconOpts).html)}
        ${tpl.if(opts.icon, () => icon(opts.icon, faIconOpts).html)}
        ${tpl.if(opts.iconAlt, () => icon(opts.iconAlt, faIconOpts).html)}
        ${tpl.if(opts.text, () => `
          <span class="text badge" data-badge="${opts.badge}">${opts.text}</span>
        `)}
      </menu-button>
    `).on(opts.evt || 'click', opts.handler);

    if (opts.tip) {
      this._initButtonTooltip(button, opts.tip);
    }

    return button;
  }

  _initButtonTooltip(button, predicate) {
    tippy(button[0], {
      placement: 'bottom',
      delay: [null, 0]
    });

    const handler = () => {
      predicate() ?
        button[0]._tippy.enable() :
        button[0]._tippy.disable();
    };

    tooltips.on('update', handler);
    handler();
  }

  _createThemeButton() {
    return $(`
      <menu-button class="theme" tabindex="0">
        ${icon(fa.adjust, faIconOpts).html}
        ${icon(fa.lightbulb, faIconOpts).html}
        ${icon(fa.lightbulbSolid, faIconOpts).html}
        ${icon(fa.lightbulbOn, faIconOpts).html}
        <ul>
          <li class="system">
            ${icon(fa.check, faIconOpts).html}
            <span class="text submenu">
              ${platform.web ? 'System' : 'Application'} Theme
            </span>
          </li>
          <li class="light">
            ${icon(fa.check, faIconOpts).html}
            <span class="text submenu">Light Theme</span>
          </li>
          <li class="dark">
            ${icon(fa.check, faIconOpts).html}
            <span class="text submenu">Dark Theme</span>
          </li>
          <li class="dark-inverted">
            ${icon(fa.check, faIconOpts).html}
            <span class="text submenu">Inverted Dark Theme</span>
          </li>
        </ul>
      </menu-button>
    `);
  }

  setItem(item) {
    this._item = item;

    const button = this._elem.find('menu-button.library');
    button.removeClass('syncing');
    button.toggleClass('synced', !!this._item);
    button.find('ul').remove();

    if (this._item) {
      button.append(`
        <ul class="align-right">
          <li class="view-in-library">
            <span class="text submenu">Open in Library</span>
          </li>
          <li class="organize">
            <span class="text submenu">Organize...</span>
          </li>
        </ul>
      `);
      button.find('li.view-in-library').click(() => {
        evtout.trigger('open-in-library', [this._item]);
      });
      button.find('li.organize').click(() => {
        const manager = new ManageItem({ item: this._item, syncApi: this._syncApi });
        manager.open();
      });
    }
  }

  _addLibraryButton() {
    const button = this._createLibraryButton();

    button.find('.import').click(() => {
      button.addClass('syncing');
      evtbus.trigger('add-to-library');
    });

    button.appendTo(this._elem.find(`[idx="${actions['library'].index}"]`).empty());
  }

  _createLibraryButton() {
    const button = $(`
      <menu-button class="library" data-tippy-content="" tabindex="0">
        <div class="import">
          ${icon(fa.spinnerThird, faIconOpts).html}
          ${icon(fa.playlistAdd, faIconOpts).html}
          <span class="text">Add to Library</span>
        </div>
        <div class="in-library">
          ${icon(fa.playlistAddCheck, faIconOpts).html}
          <span class="text">In Library</span>
        </div>
      </menu-button>
    `);

    // this._initButtonTooltip(button, actions['library'].tip);

    return button;
  }
}

module.exports = MenuBar;

